import React from 'react';
import { string, number } from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import classNames from 'classnames';

import Breadcrumbs from './Breadcrumbs/Breadcrumbs';
import css from './MainPanelHeader.module.css';

const MainPanelHeader = props => {
  const { rootClassName, className, totalItems } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <Breadcrumbs />
      <h3 className={css.title}>
        <FormattedMessage
          id="SearchBrandsPage.MainPanelHeader.totalItems"
          values={{
            count: totalItems,
          }}
        />
      </h3>
    </div>
  );
};

MainPanelHeader.defaultProps = {
  rootClassName: null,
  className: null,
  totalItems: 0,
};

MainPanelHeader.propTypes = {
  rootClassName: string,
  className: string,
  totalItems: number,
};

export default MainPanelHeader;
